import {fr, enUS, ar} from "date-fns/locale";
import {useTranslation} from "react-i18next";

// date-fns locale objects keyed by our supported i18next languages.
const DATE_FNS_LOCALES = {fr, en: enUS, ar};

export const getDateFnsLocale = (lng) => DATE_FNS_LOCALES[lng] || fr;

// Reactive date-fns locale — re-renders consumers when the language changes.
export const useDateFnsLocale = () => {
    const {i18n} = useTranslation();
    return getDateFnsLocale(i18n.language);
};
